import React from "react";
import StatusScreen from "../components/StatusScreen";

const MaintenanceScreen = ({ message }) => (
  <StatusScreen badge="Down for maintenance" badgeTone="warning" title="We'll be right back" zIndex={2147483647}>
    <p className="m-0">{message || "ChipMonk is being updated and is briefly unavailable."}</p>
    <p className="mt-6 mb-0 text-sm">Please try again in a few minutes. This page refreshes on its own.</p>
  </StatusScreen>
);

export default MaintenanceScreen;
